import React from 'react';
import { SketchPicker } from 'react-color';

class ColorPicker extends React.Component {
	state = {
		displayColorPicker: false,
		color: {
			r: '241',
			g: '112',
			b: '19',
			a: '1',
		},
		selected: ''
	};

	handleClick = () => {
		this.setState({ displayColorPicker: !this.state.displayColorPicker });
	};

	handleClose = () => {
		this.setState({ displayColorPicker: false });
	};

	handleChange = (color) => {
		this.setState({ color: color.rgb });
	};

	handleChangeComplete = (color) => {
		this.props.onChangeColor(color.hex);
	};

	handleTransparentClick = () => {
		this.props.onChangeColor('transparent');
		this.setState({ displayColorPicker: false });
	};

	hexToRgb = (hex) => {
		// Handle transparent case
		if (hex === 'transparent') {
			return {
				r: 0,
				g: 0,
				b: 0,
				a: 0
			};
		}
		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
		return result ? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16),
			a: result[4] ? parseInt(result[4], 16) / 255 : 1
		} : null;
	};

	renderColorOnce = () => {
		if (this.props.selected) {
			let selected = this.state.selected;
			let color = this.state.color;
			if (selected !== this.props.selected) {
				const parsedColor = this.hexToRgb(this.props.selected);
				if (parsedColor !== null) {
					color.r = parsedColor.r;
					color.g = parsedColor.g;
					color.b = parsedColor.b;
					color.a = parsedColor.a;
				}
				selected = this.props.selected;
			}
			return color;
		}
	};

	render() {
		const isTransparent = this.props.selected === 'transparent';
		const colorSwatchStyle = {
			background: isTransparent ? 'transparent' : `${this.props.selected}`,
			width: '16px',
			height: '16px',
			borderRadius: '2px',
			border: isTransparent ? '1px dashed #ccc' : 'none',
			position: 'relative'
		};
		const transparentIndicator = isTransparent ? (
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				width: '12px',
				height: '2px',
				background: '#999',
				transform: 'translate(-50%, -50%) rotate(45deg)'
			}} />
		) : null;
		const swatchStyle = {
			background: 'transparent',
			display: 'inline-block',
			cursor: 'pointer',
			borderRadius: '2px',
			boxShadow: '0 0 3px 2px rgb(0 0 0 / 20%)'
		};
		let drawingStyle = {};
		if (this.props.popoverPos === 'top') {
			drawingStyle = {
				top: '-300px',
				right: '50px'
			};
		}
		let color = this.renderColorOnce();
		return (
			<div className="color-picker" name={this.props.name}>
				<div className="swatch-container" style={swatchStyle} onClick={this.handleClick}>
					<div className="swatch-color" style={colorSwatchStyle}>
						{transparentIndicator}
					</div>
				</div>
				{this.state.displayColorPicker ? (
					<div className="picker-modal" style={drawingStyle}>
						<div className="picker-cover" onClick={this.handleClose} />
						<div style={{ position: 'relative' }}>
							<SketchPicker color={color} onChange={this.handleChange} onChangeComplete={this.handleChangeComplete} />
							<div style={{
								position: 'absolute',
								top: '10px',
								right: '10px',
								zIndex: 1
							}}>
								<button
									onClick={this.handleTransparentClick}
									style={{
										padding: '8px 12px',
										background: '#f0f0f0',
										border: '1px solid #ccc',
										borderRadius: '4px',
										cursor: 'pointer',
										fontSize: '12px',
										fontWeight: 'bold',
										margin: '0'
									}}
									title="Select transparent color"
								>
									Transparent
								</button>
							</div>
						</div>
					</div>
				) : null}
				<span className="picker-value" style={{ marginLeft: '5px', marginTop: '5px' }} hidden={this.props.hideSelected} >{this.props.selected}</span>
			</div>
		);
	}
}

export default ColorPicker;